import { Typography, type TypographyProps } from "@octopus-energy/coral/atoms"

export function DataGridLabel(props: TypographyProps) {
    return (
        <Typography
            textStyle="body1"
            {...props}
        />
    )
}
